export default __webpack_public_path__ + "static/media/bordc.830dac77.svg";